<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('提现.兑换积分')" class="nav-bar">
      <template #left>
        <img src="/img/common/icon-back.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="withdraw_money" :placeholder="$t('提现.最大提款金额')" />
      <van-field v-model="paypassword" :placeholder="$t('提现.资金密码')" />
    </van-cell-group>
    <div class="p_c">
      <span>{{ $t('提现.余额') }}</span>
      <span class="number">{{ this.userInfo.balance }}{{ $t('提现.个') }}</span>
    </div>

    <div class="hang_p_c">
      <div class="select-label">{{ $t('提现.钱包地址') }}</div>
      <div class="custom-select" @click.stop="toggleDropdown">
        <div class="select-trigger" :class="{ active: showDropdown }">
          <span v-if="selectedBank" class="trigger-value">
            {{ selectedBank.chain }} : {{ selectedBank.address }}
          </span>
          <span v-else class="trigger-placeholder">{{ $t('提现.请选择提款地址') }}</span>
          <span class="trigger-arrow" :class="{ open: showDropdown }">▾</span>
        </div>
        <div v-if="showDropdown" class="select-menu">
          <div
            v-for="item in bankList"
            :key="item.id"
            class="select-item"
            :class="{ selected: selectedBank && selectedBank.id === item.id }"
            @click.stop="selectBank(item)"
          >
            <span class="item-icon">{{ item.chain === 'BTC' ? '₿' : 'Ξ' }}</span>
            <span class="item-text">{{ item.chain }} : {{ item.address }}</span>
            <span v-if="selectedBank && selectedBank.id === item.id" class="item-check">✓</span>
          </div>
          <div v-if="bankList.length === 0" class="select-empty">
            {{ $t('提现.暂无绑定地址') }}
          </div>
        </div>
      </div>
    </div>

    <div class="sub-btn" @click="doWithdraw()">
      {{ $t('提现.提交') }}
    </div>
    <div class="shuoming">
      <div class="l_p q1">{{ $t('提现.通知') }}</div>
      <div class="l_p">{{ $t('提现.单笔最大提现') }}{{ getCurrentLevelWithdrawMax() }}{{ $t('提现.个') }}</div>
      <div class="l_p">{{ $t('提现.单笔最低提现') }}{{ getCurrentLevelWithdrawMin() }}{{ $t('提现.个') }}</div>
      <div class="l_p">{{ $t('提现.检查姓名账号') }}</div>
      <div class="l_p">{{ $t('提现.注意提款费用') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      money: "",
      paypassword: "",
      withdraw_money: "",
      userInfo: {},
      withdrawRole: {},
      bankList: [],
      selectedBank: null,
      showDropdown: false,
      currentLevel: null
    };
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    selectBank(item) {
      this.selectedBank = item;
      this.showDropdown = false;
    },

    getCurrentLevel() {
      if (!this.userInfo.all_levels || !this.userInfo.vip) return null;
      return this.userInfo.all_levels.find(level => level.name === this.userInfo.vip);
    },

    getCurrentLevelWithdrawMax() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_max_amount : '0';
    },

    getCurrentLevelWithdrawMin() {
      const level = this.getCurrentLevel();
      return level ? level.withdraw_min_amount : '0';
    },

    getCurrentLevelMinCompletedOrders() {
      const level = this.getCurrentLevel();
      return level ? level.min_completed_orders : 0;
    },

    getUserBankInfo() {
      this.$http({ method: 'get', url: 'user_get_bank' }).then(res => {
        if (res.code === 200 && res.data.is_bank) {
          this.bankList = [res.data.info];
          this.selectedBank = res.data.info;
        }
      });
    },

    back() {
      return window.history.back();
    },

    goSetPayPassword() {
      this.$toast(this.$t('提现.请先设置提现密码'));
      this.$router.replace({ path: '/SetPayPassword' });
    },

    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (!this.userInfo.paypassword) {
            this.goSetPayPassword();
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getUserWithdrawRole() {
      this.$http({ method: 'get', url: 'user_get_withdraw_role' }).then(res => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        }
      });
    },

    doWithdraw() {
      console.log('1 paypassword:', this.paypassword);
      console.log('2 withdraw_money:', this.withdraw_money);
      console.log('3 selectedBank:', this.selectedBank);
    
      if (!this.paypassword) {
        this.$toast(this.$t('提现.资金密码'));
        return false;
      }
      if (!this.withdraw_money) {
        this.$toast(this.$t('提现.请填写正确的金额'));
        return false;
      }
      if (!this.selectedBank) {
        this.$toast(this.$t('提现.请选择提款地址'));
        return false;
      }
    
      this.$http({
        method: 'post',
        data: {
          money: this.withdraw_money,
          paypassword: this.paypassword
        },
        url: 'user_set_withdraw'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.getUserInfo();
          this.withdraw_money = '';
          this.paypassword = '';
          return;
        }
        if (res.msg && String(res.msg).indexOf('设置提现密码') !== -1) {
          this.goSetPayPassword();
          return;
        }
        this.$toast(res.msg);
      });
    },
  },

  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.p_c {
  color: #fff;
  padding: 0 30px 20px;
  font-size: 28px;
}

.hang_p_c {
  padding: 0 30px 20px;
  margin: 0 0 10px;

  .select-label {
    color: #c5a081;
    font-size: 28px;
    margin-bottom: 16px;
  }

  .custom-select {
    position: relative;

    .select-trigger {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: linear-gradient(120deg, #212121, #313131);
      border: 1px solid #766350;
      border-radius: 10px;
      padding: 20px 26px;
      cursor: pointer;

      &.active {
        border-color: #e6b98a;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      .trigger-value {
        font-size: 28px;
        color: #f3c7a2;
        word-break: break-all;
        flex: 1;
        margin-right: 10px;
      }

      .trigger-placeholder {
        font-size: 28px;
        color: #555;
      }

      .trigger-arrow {
        font-size: 28px;
        color: #766350;
        transition: transform 0.25s ease;
        flex-shrink: 0;
        &.open { transform: rotate(180deg); }
      }
    }

    .select-menu {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      background: linear-gradient(120deg, #2a2a2a, #383838);
      border: 1px solid #e6b98a;
      border-top: none;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      z-index: 100;
      box-shadow: 0 8px 24px rgba(0,0,0,0.4);

      .select-item {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 24px 26px;
        cursor: pointer;
        border-bottom: 1px solid #333;

        &:last-child { border-bottom: none; }
        &:active { background: rgba(230,185,138,0.08); }

        &.selected {
          background: rgba(230,185,138,0.12);
          .item-text { color: #e6b98a; }
        }

        .item-icon {
          font-size: 32px;
          color: #f7931e;
          width: 40px;
          text-align: center;
          flex-shrink: 0;
        }

        .item-text {
          flex: 1;
          font-size: 26px;
          color: #f3c7a2;
          word-break: break-all;
        }

        .item-check {
          font-size: 28px;
          color: #e6b98a;
          font-weight: 700;
          flex-shrink: 0;
        }
      }

      .select-empty {
        padding: 24px 26px;
        font-size: 26px;
        color: #555;
        text-align: center;
      }
    }
  }
}

.sub-btn {
  background: linear-gradient(#fde3ca, #e7b486);
  display: block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  border-radius: 2rem;
  margin: 40px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}

.shuoming {
  background: #2e2e2e;
  color: #c1c1c1;
  padding: 40px 36px;
  .l_p {
    font-size: 26px;
    margin-top: 16px;
    &.q1 { font-size: 30px; }
  }
}

.van-cell-group {
  background-color: transparent;
  padding: 30px 0;
  &:after { display: none; }
}

.van-cell {
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  &+.van-cell { margin-top: 30px; }
  /deep/ .van-field__control { color: #f3c7a2; }
  &:after { display: none; }
}
</style>
